<template>
  <RequestRequested
    request-type="leave"
    :notification="notification"
    :active-notification="activeNotification"
    @show-more-details="showMoreDetails"
  />
</template>

<script>
import RequestRequested from '@/components/notifications/RequestRequested'
import Notification from '@/components/notifications/mixins/Notification'

export default {
  name: 'LeaveRequested',

  components: {
    RequestRequested,
  },

  mixins: [Notification],

  methods: {
    showMoreDetails() {
      this.$emit('click', this.notification)
    },
  },
}
</script>
